import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import { localeData } from '../../../locales/data';
import { formatMessageHelper } from '../../../shared/helpers/internationalization';

import './CloseAlphaProperties.scss';

interface CloseAlphaPropertiesProps {
  handleCancelCloseAlphaProperties: () => void;
  handleSaveAlphaProperties: () => void;
  handleNotSaveCloseAlphaProperties: () => void;
}

export const CloseAlphaPropertiesIntl = ({
  handleCancelCloseAlphaProperties,
  handleSaveAlphaProperties,
  handleNotSaveCloseAlphaProperties,
  intl,
}: CloseAlphaPropertiesProps & InjectedIntlProps) => (
  <div>
    <header className="modal__header">
      <h3 className="modal__title modal__title--edit-properties">{formatMessageHelper(intl, 'closeAlphaProperties.title')}</h3>
    </header>

    <div className="close-tab__modal--content">
      <div>{formatMessageHelper(intl, 'closeAlphaProperties.content')}</div>
      <div className="close-tab__modal-section--buttons">
        <button onClick={handleNotSaveCloseAlphaProperties} className="button button--md button--secondary">
          {formatMessageHelper(intl, 'closeAlphaProperties.button.not.save')}
        </button>
        <button onClick={handleCancelCloseAlphaProperties} className="button button--md  button--secondary">
          {intl.formatMessage({
            id: 'closeAlphaProperties.button.cancel',
            defaultMessage: localeData.en['closeAlphaProperties.button.cancel'],
          })}
        </button>
        <button onClick={handleSaveAlphaProperties} className="button button--md  button--primary">
          {formatMessageHelper(intl, 'closeAlphaProperties.button.close')}
        </button>
      </div>
    </div>
  </div>
);

export const CloseAlphaProperties = injectIntl(CloseAlphaPropertiesIntl);
